import { createAction } from '@reduxjs/toolkit';
import { withPayloadType } from '@zz2/zz2-ui';

export default class RightActions {
    public static setSelectedUserDivisionIds = createAction('RIGHT_SET_USER_SELECTED_DIVISION_IDS', withPayloadType<Array<number>>());
    public static setSelectedUserPrintServerIds = createAction('RIGHT_SET_USER_SELECTED_PRINT_SERVER_IDS', withPayloadType<Array<number>>());
    public static setSelectedResponsibleEmployeeId = createAction('RIGHT_SET_SELECTED_RESPONSIBLE_EMPLOYEE_ID', withPayloadType<number | null>());
    public static reset = createAction('RIGHT_RESET');
}